import VideoTile from '@components/VideoTile';
import styled from '@emotion/styled';

export const Container = styled(VideoTile)`
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  margin: 0;
  border-radius: 6px;
  background-color: #161616;
`;
